<template>
<div class="main my">
  <!-- 添加练球卡 -->
  <div class="model-box bcw fs2 clear">
    <h2 class="fs4 tac mtn mbw">练球卡</h2>
    <van-row class="mbn plm">
      <van-col span="6">练球次数</van-col>
      <van-col span="18">{{classInfo.useNum}}次</van-col>
    </van-row>
    <van-row class="mbn plm">
      <van-col span="6">有效期</van-col>
      <van-col span="18">{{classInfo.timeSpan}}天</van-col>
    </van-row>
    <van-row class="mbn plm">
      <van-col span="6">场馆</van-col>
      <van-col span="18">{{classInfo.clubTitle}}</van-col>
    </van-row>
    <div class="right mtm mbw">总价：<span class="red fs4">￥{{classInfo.price}}元</span></div>
  </div>

  <form class="clear" @submit.prevent="checkForm" v-cloak>
    <van-cell-group>
      <van-field v-model="userInfo.name" label="姓名" placeholder="请输入" clearable :disabled="true" />
      <van-field v-model="userInfo.mobile" type="tel" label="电话" placeholder="请输入" clearable :disabled="dised"/>
      <van-cell
        title="支付方式"
        value="现金支付"
        is-link/>
    </van-cell-group>
    <the-btnbar :loadSta="subSta" text="创建订单"></the-btnbar>
  </form>

</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import TheBtnbar from './components/TheBtnBar';
import {
  Cell, CellGroup,Checkbox, CheckboxGroup,SwitchCell,Picker,Toast
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Checkbox).use(CheckboxGroup).use(SwitchCell).use(Picker).use(Toast);

export default {
  components: {
    TheBtnbar
  },
  data() {
    return {
      dised:false, //默认可以编辑
      subSta:false, //提交时 按钮状态
      classInfo:{}, //课程信息
      userInfo:{
        name:'',
        mobile:''
      },
      postForm:{
        userId:this.$route.query.userId,
        targetId:'',
        targetType:'clubPracticeCard',
        data:{}
      }
    }
  },
  created(){
    let uid = this.$route.query.userId

    let _this = this
    // 获取用户信息
    if(uid){
      _this.$http.post('user/get',{
        id:uid
      }).then(function(res){
        if(!res.data.code){
          _this.userInfo.name = res.data.value.nickname
          
          if(res.data.value.mobile!==''){
            _this.userInfo.mobile = res.data.value.mobile
            _this.dised = true //有手机号不能修改
          }
        }else{
          // Toast(res.data.message)
        }
      })
    }

    // 获取卡信息
    _this.$http.post('product_manage/getInfoByCategoryCode',{
      code:'DAYS_CARD'
    }).then(function(res){
      if(!res.data.code){
        _this.classInfo = res.data.value
        _this.postForm.targetId = res.data.value.id
      }else{
        // Toast(res.data.message)
      }
    })
  },
  methods: {
    validMobile:function(value){
      let reg=11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (value && !reg.test(value)) {
        return false
      } else {
        return true
      }
    },
    checkForm: function(){
      
      // if(!this.validMobile(this.userInfo.mobile)){
      //   Toast.fail('手机号格式不正确'); return false;
      // }

      let _this = this
      let temp = JSON.parse(JSON.stringify(_this.postForm))
      temp.data.userInfo = _this.userInfo
      temp.data = JSON.stringify(temp.data)
      

      _this.subSta = true
      // 提交表单
      _this.$http.post('order_manage/create',temp).then(function(res){
          if(res.data.code == 0){
            Toast.success({                
              message:'创建成功！',
              duration:1000 
            })
            setTimeout(function(){
              _this.$router.go(-1) //当前页跳转，防止手机上点击返回按键多次添加
            }, 1000) 
          }else{
            Toast(res.data.message)
            _this.subSta = false
          }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.quan-box{
  padding:.1rem .15rem;
  &>h4{
    font-size: .14rem;
    padding-bottom: .1rem;
  }
  & .checkbox{
    float: left;
    width: 30%;
    margin-right: 1%;
    margin-bottom: .1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/CardAdd.vue